const logoutConstants = {
  LOGOUT_REQUEST: 'USER_LOGOUT_REQUEST',
  LOGOUT_SUCCESS: 'USER_LOGOUT_SUCCESS',
  LOGOUT_FAILURE: 'USER_LOGOUT_FAILUTE',
};

export default logoutConstants;
